import { render, staticRenderFns } from "./OnboardingPassword.vue?vue&type=template&id=1f442fa5&scoped=true&"
import script from "./OnboardingPassword.vue?vue&type=script&lang=js&"
export * from "./OnboardingPassword.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPassword.vue?vue&type=style&index=0&id=1f442fa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f442fa5",
  null
  
)

export default component.exports